import { Fragment } from "react/jsx-runtime";
import Content from "../../../../components/Content/Content";
import ContentHeader from "../../../../components/ContentHeader/ContentHeader";
import ContentWrapper from "../../../../components/ContentWrapper/ContentWrapper";
import { useDispatch, useSelector } from "react-redux";
import { prevStep } from "../../../../redux/slices/projectDetailsSlice";
import { useState } from "react";
import { RootState } from "../../../../redux/store";
import FolderStructure from "../../../../components/FolderCard/FolderStructure";
import Editor from "../../../../components/EditorCard/Editor";
import Chatbot from "../../../../components/ChatbotCard/Chatbot";
import { CodeContent } from "../../../../types/codeBaseType";
import './ProjectFilesWithChat.scss';

export default function ProjectFilesWithChat() {

    const dispatch = useDispatch();
    const { selectedProject } = useSelector((state: RootState) => state.projectDetails);

    const [codeContent, setCodeContent] = useState<CodeContent>({ fileName: "", content: "", fullFilePath: "" });
    const [suggestionClicked, setSuggestionClicked] = useState(false)

    const handlePreviousStep = () => {
        dispatch(prevStep())
    }

    const handleContentChange = (hashmap: CodeContent) => {
        console.log("hashmap", hashmap)
        setCodeContent(hashmap);
        setSuggestionClicked(false)
    };

    return (
        <ContentWrapper>
            <Fragment>
                <ContentHeader
                    title={"Project Details"}
                    subTitle={`Projects / ${selectedProject?.p_name}`}
                    handleBack={handlePreviousStep}
                />
                <Content isFullHeight>
                    <div className="files-and-chat-wrapper">
                        <FolderStructure onContentChange={handleContentChange} content={codeContent} />
                        <Editor content={codeContent} />
                        <Chatbot fileDetails={codeContent} suggestionClicked={suggestionClicked} setSuggestionClicked={setSuggestionClicked} />
                    </div>
                </Content>
            </Fragment>
        </ContentWrapper>
    )
}